<template lang="pug">
v-card
  v-divider
  transition-group(
    enter-active-class="animated rollIn  faster",
    leave-active-class="animated rollOut faster"
  )
    v-card-text.pa-0(v-for="order in orders", :key="order.id")
      v-list-item
        v-list-item-content
          v-list-item-title
            v-icon(
              small,
              color="red",
              v-if="inExecMode() && selectedService && selectedService.id == order._serviceKey"
            ) mdi-star
            span(@click="inExecMode() && toggleServiceFromOrder(order)")
              | {{ order.productCode }}:
              strong {{ order.productName }}
            v-menu(v-if="inCartMode()", offset-x)
              template(v-slot:activator="{ on }")
                code(v-on.stop="on") Qty:[{{ order.quantity }}]
              v-list
                v-list-item(
                  v-for="i in getMaxQuantity(order)",
                  :key="i",
                  @click="vibrate(); order.quantity = i; updatePrice(order)"
                ) {{ i }}
            code(v-else) Qty:[{{ order.quantity }}]
          v-list-item-title.text--primary
            small Counter:
            code {{ order.counterCode }}
            small Section:
            code {{ order.sectionCode }}
            small Seat:
            v-menu(v-if="inCartMode()", offset-y)
              template(v-slot:activator="{ on }")
                code(v-on.stop="on") {{ order.seat }}
              v-list
                v-list-item(
                  v-for="seat in options.seats",
                  :key="seat",
                  @click="vibrate(); order.seat = seat; updateOrder(order.id, { seat: order.seat })"
                )
                  v-list-item-title {{ seat }}
            code(v-else) {{ order.seat }}
          v-list-item-title.text--primary
            v-menu(v-if="inCartMode()", offset-y)
              template(v-slot:activator="{ on }")
                small Custom:
                code(v-on.stop="on") [{{  order.tags.join(&apos;,&apos;) || &apos;Standard&apos;  }}]
              v-list
                v-list-item(
                  v-for="t in customOptions",
                  :key="t",
                  @click="vibrate(); updateTags(order, t)"
                ) {{ t }}
            template(v-else)
              small Custom:
              code [{{  order.tags.join(&apos;,&apos;) || &apos;Standard&apos;  }}]
            v-menu(
              v-if="inTrackMode() && myFeatures.eligibleFeatures.includes('BILLSPLIT')",
              offset-x
            )
              template(v-slot:activator="{ on }")
                small Bill#:
                code(v-on.stop="on") [{{ order.billNum }}]
              v-list
                v-list-item(
                  v-for="i in 9",
                  :key="i",
                  @click="vibrate(); order.billNum = i"
                ) {{ i }}
        v-list-item-action
          v-list-item-action-text(v-if="inCartMode()") (@{{ order.rate }}) &#x20B9;{{ order.price }}
          v-list-item-action-text(v-else)
            template(
              v-if="myFeatures.eligibleFeatures.includes('TIMER') && order.status != STATUSES.CLEARED"
            )
              span(
                :key="ageKey",
                v-bind:class="{ blink: isStatusDelayed(order) }"
              ) {{ getStatusAge(order) }}m
              | ,
              span(
                :key="ageKey + 1",
                v-bind:class="{ blink: isTotalDelayed(order) }"
              ) {{ getTotalAge(order) }}m
            template(v-else)
              span
                | {{  moment(order.status == STATUSES.CLEARED ? order.lastUpdatedTS : order.createdTS).format(&apos;LT&apos;)  }}
          v-list-item-action-text
            v-icon(
              v-if="!inCartMode() && order.sosFlag && myFeatures.eligibleFeatures.includes('WORKFLOW')",
              :color="order.sosFlag ? 'red' : 'grey lighten-1'",
              @click="vibrate(); toggleFlag(order)"
            ) mdi-flag
            v-icon(
              v-if="inExecMode() && isNextAllowed(order) && !order.sosFlag",
              @click="moveNext(order)",
              color="green"
            ) mdi-send
            span(v-if="inCartMode()")
              v-icon(color="green", @click="vibrate(); moveNext(order)") mdi-send
            span(
              v-if="inTrackMode() && isNextAllowed(order) && !myFeatures.eligibleFeatures.includes('WORKFLOW')"
            )
              v-icon(color="green", @click="vibrate(); moveNext(order)") mdi-send
            v-menu(offset-x)
              template(v-slot:activator="{ on }")
                v-icon(
                  v-on.stop="on",
                  @click="vibrate()",
                  color="grey lighten-1"
                ) mdi-dots-vertical
              v-list
                v-list-item(@click="vibrate(); printOrder(order)")
                  v-icon(small) mdi-printer
                  v-list-item-title.pl-2 Print
                v-list-item(
                  v-if="['GA', 'RM', 'SS'].includes(selectedUser && selectedUser.role) && inExecMode()",
                  @click="vibrate(); trackService(order)"
                )
                  v-icon(small) mdi-pencil
                  v-list-item-title.pl-2 Track Service
                v-list-item(
                  v-if="inTrackMode() && order.status < STATUSES.CLEARED",
                  @click="vibrate(); gotoAreaOrders(order)"
                )
                  v-icon(small) mdi-pencil
                  v-list-item-title.pl-2 Goto {{ getNavigationLabel(order) }}
                v-list-item(
                  v-if="myFeatures.eligibleFeatures.includes('VOICE')",
                  @click="vibrate(); speak(`Attention Counter ${order.counterCode} - New Order, ${order.quantity} ${order.productName} - from ${order.sectionCode} - ${order.tags.join(',') || 'Standard'} `)"
                )
                  v-icon(small) mdi-volume-high
                  v-list-item-title.pl-2 Announce
                v-list-item(
                  v-if="inTrackMode()",
                  @click="vibrate(); repeatOrder(order)"
                )
                  v-icon(small) mdi-refresh
                  v-list-item-title.pl-2 Repeat
                v-list-item(
                  v-if="!inCartMode() && myFeatures.eligibleFeatures.includes('WORKFLOW')",
                  @click="vibrate(); toggleFlag(order)"
                )
                  v-icon(
                    small,
                    :color="order.sosFlag ? 'red' : 'grey lighten-1'"
                  ) mdi-flag
                  v-list-item-title.pl-2 {{ order.sosFlag ? 'Release' : 'Raise' }} Flag
                v-list-item(
                  v-if="inCartMode() || order.sosFlag",
                  @click="vibrate(); deleteOrder(order)"
                )
                  v-icon(small) mdi-delete
                  v-list-item-title.pl-2 Remove
          v-list-item-action-text
            span(
              v-if="inCartMode() && !myFeatures.eligibleFeatures.includes('TIMER')"
            ) {{  moment(order.createdTS).format(&apos;LT&apos;)  }}
            span(
              v-if="inCartMode() && myFeatures.eligibleFeatures.includes('TIMER')",
              :key="ageKey",
              v-bind:class="{ blink: isTotalDelayed(order) }"
            ) {{ getTotalAge(order) }}m
      v-divider
</template>

<script>
import moment from "moment";
import { storeMixin } from "../../mixins/storeMixin.js";
export default {
  name: "ezorderlist",
  mixins: [storeMixin],
  props: { orders: Array, options: Object }, //options.mode = 'track', 'cart', 'exec'
  beforeMount() {
    this.ageTimer = setInterval(() => {
      if (!this.ageKey) this.ageKey = 1;
      this.ageKey *= -1;
    }, 60000);
    this.customOptions = this.getCustomTags();
  },
  beforeDestroy() {
    clearInterval(this.ageTimer);
  },
  data() {
    return {
      ageKey: 1,
      customOptions: [],
      moment: moment,
    };
  },
  methods: {
    inTrackMode() {
      return (
        this.options &&
        this.options.mode &&
        this.options.mode.toLowerCase() === "track"
      );
    },
    inCartMode() {
      return (
        this.options &&
        this.options.mode &&
        this.options.mode.toLowerCase() === "cart"
      );
    },
    toggleServiceFromOrder(order) {
      if (
        this.selectedService &&
        this.selectedService.id == order._serviceKey
      ) {
        this.selectService(null);
      } else {
        const service = this.activeRestaurantServices.find(
          (s) => s.id == order._serviceKey
        );
        this.selectService(service);
      }
    },
    getMaxQuantity(order) {
      let q = 9;
      if (this.myFeatures.eligibleFeatures.includes("INVENTORY")) {
        const product = this.restaurantProducts.find(
          (p) => p.id === order._productKey
        );
        q = (product && product.count) <= 9 ? product.count : 9;
      }
      return Number(q);
    },
    inExecMode() {
      return (
        this.options &&
        this.options.mode &&
        this.options.mode.toLowerCase() === "exec"
      );
    },
    isNextAllowed(order) {
      let allowed = false;
      switch (order.status) {
        case this.STATUSES.QUEUED:
        case this.STATUSES.PREPON:
          allowed = ["GA", "RM", "CC"].includes(this.selectedUser.role);
          break;
        case this.STATUSES.READY:
        case this.STATUSES.INTRANSIT:
          allowed = ["GA", "RM", "SS", "SW"].includes(this.selectedUser.role);
          break;
        case this.STATUSES.SERVED:
          allowed =
            ["GA", "RM", "SS", "SH"].includes(this.selectedUser.role) &&
            this.myFeatures.eligibleFeatures.includes("WORKFLOW");
          break;
        default:
          allowed = false;
      }
      return allowed;
    },
    getTotalAge(order) {
      const age = Math.round((Date.now() - order.createdTS) / 60000);
      return age > 60 ? ">60" : age;
    },
    getStatusAge(order) {
      const age = Math.round((Date.now() - order.lastUpdatedTS) / 60000);
      return age > 30 ? ">30" : age;
    },
    isStatusDelayed(order) {
      const age = this.getStatusAge(order);
      return isNaN(age) || age > 5;
    },
    isTotalDelayed(order) {
      const age = this.getTotalAge(order);
      return isNaN(age) || age > 15;
    },
    updatePrice(order) {
      let rate = order.rate;
      let quantity = order.quantity;
      let price = parseFloat(rate) * parseFloat(quantity);
      order.price = price.toFixed(2);
      this.updateOrder(order.id, {
        quantity: order.quantity,
        price: order.price,
      });
    },
    moveNext(order) {
      if (this.myFeatures.eligibleFeatures.includes("WORKFLOW")) {
        order.status = Number(order.status) + 1;
        if (order.status === this.STATUSES.PREPON) {
          this.decrementInventory(order);
        }
      } else {
        switch (order.status) {
          case this.STATUSES.QUEUED:
          case this.STATUSES.PREPON:
          case this.STATUSES.READY:
          case this.STATUSES.INTRANSIT:
          case this.STATUSES.SERVED:
            order.status = this.STATUSES.CLEARED;
            this.decrementInventory(order);
            break;
          case this.STATUSES.CLEARED:
            order.status = Number(order.status) + 1;
            break;
          default:
            order.status = Number(order.status) + 1;
        }
      }
      order.trace.push(
        Math.round(
          (Date.now() - (order.lastUpdatedTS || order.createdTS)) / 1000
        ) +
          "-" +
          order.status
      );
      this.updateOrder(order.id, { status: order.status, trace: order.trace });
    },
    toggleFlag(order) {
      order.sosFlag = !order.sosFlag;
      order.trace.push(
        Math.round(
          (Date.now() - (order.lastUpdatedTS || order.createdTS)) / 1000
        ) + "-F"
      );
      this.updateOrder(order.id, {
        sosFlag: order.sosFlag,
        trace: order.trace,
      });
    },
    decrementInventory(order) {
      if (this.myFeatures.eligibleFeatures.includes("INVENTORY")) {
        const product = this.restaurantProducts.find(
          (p) => p.id === order._productKey || p.code === order.productCode
        );

        product.count = Number(product.count) - Number(order.quantity);
        this.updateFields({
          collectionName: "products",
          docId: product.id,
          subDoc: { count: product.count },
        });
      }
    },
    getCustomTags() {
      return this.selectedGroup.customTags.split(",");
    },
    updateTags(order, tag) {
      const index = order.tags.indexOf(tag);
      if (index != -1) {
        order.tags.splice(index, 1);
      } else {
        order.tags.push(tag);
      }
      this.updateOrder(order.id, { tags: order.tags });
    },
    updateOrder(orderId, subDoc) {
      this.updateFields({
        collectionName: "orders",
        docId: orderId,
        subDoc,
      });
    },
    deleteOrder(order) {
      this.deleteDoc({
        collectionName: "orders",
        docId: order.id,
      });
    },
    printOrder(order) {
      //const maxCol = 32;
      let lines = [];
      lines.push("--------------------------------");
      lines.push(
        `Counter:${order.counterCode} Section:${order.sectionCode} Seat:${order.seat}`
      );
      lines.push(
        `Timestamp: ${moment(order.lastUpdatedTS || order.createdTS).format(
          "DD-MMM-YYYY LT"
        )}`
      );
      lines.push(`${order.productName.padEnd(25, " ")} Qty[${order.quantity}]`); //max-6
      lines.push(
        `Custom: ${
          order.tags && order.tags.length ? order.tags.join(",") : "Standard"
        }`
      );
      lines.push("--------------------------------");
      this.print(lines.join("\n                                \n"));
    },
    repeatOrder(order) {
      const newOrder = Object.assign({}, order);
      delete newOrder.id;
      delete newOrder.lastUpdatedBy;
      delete newOrder.lastUpdatedTS;
      newOrder.status = 0;
      newOrder.price = newOrder.price / newOrder.quantity;
      newOrder.quantity = 1;
      newOrder.trace = [];
      this.createDoc({ collectionName: "orders", doc: newOrder });
    },
    trackService(order) {
      const serviceId = order._serviceKey;
      const sectionId = order._sectionKey;
      this.selectSection(
        this.mySections.find((s) => s._sectionKey == order._sectionKey)
      );
      const tab = 2; //track tab
      this.$router.push(
        `/restaurants/${this.selectedRestaurant.id}/sections/${sectionId}/services/${serviceId}/${tab}`
      );
    },
    getNavigationLabel(order) {
      let label = "Restaurant";
      if (order.status < this.STATUSES.READY) {
        label = "Counter";
      } else {
        if (order.status < this.STATUSES.CLEARED) {
          label = "Section";
        }
      }
      return label;
    },
    gotoAreaOrders(order) {
      let route = `/restaurants/${this.selectedRestaurant.id}/orders`;
      const counterId = order._counterKey;
      const sectionId = order._sectionKey;
      if (order.status < this.STATUSES.READY) {
        route = `/restaurants/${this.selectedRestaurant.id}/counters/${counterId}/orders`;
      } else {
        if (order.status < this.STATUSES.CLEARED) {
          route = `/restaurants/${this.selectedRestaurant.id}/sections/${sectionId}/orders`;
        }
      }
      this.$router.push(route);
    },
  },
};
</script>
 
<style >
.v-list__tile--avatar {
  height: 70px;
}
.blink {
  animation: blinkingText 1s infinite;
}
@keyframes blinkingText {
  0% {
    color: red;
  }
  50% {
    color: transparent;
  }
  100% {
    color: red;
  }
}
</style>


